/* eslint-disable react/prop-types */
import React from 'react';

const ChoiceImage = ({ mediaUrl, disabled }) => {
  return (
    <img
      className={disabled ? 'choice-image--disabled' : 'choice-image'}
      aria-label="clickable-choice"
      src={mediaUrl}
      alt="choice"
      height={100}
      width={100}
    />
  );
};

export default ChoiceImage;
